import withQuestionSearchData from "./withQuestionSearchData";
import QuestionSearch from "./QuestionSearch";

export default withQuestionSearchData(QuestionSearch);
